import { Action, Reducer } from 'redux';
import * as Actions from '../actions';
import * as ActionEvents from '../actions/PersonPhones.Actions';
import { PersonPhoneState, PersonPhoneUnloadState } from '../states/PersonPhoneState';
import { PhoneViewModel } from '../../models/Entities/Person/Phone/PhoneModels';

export type KnownAction =
    | Actions.PersonPhones.PersonPhoneGetAllRequestAction
    | Actions.PersonPhones.PersonPhoneGetAllSuccessAction
    | Actions.PersonPhones.PersonPhoneGetAllFailureAction
    | Actions.PersonPhones.PersonPhoneGetByIdRequestAction
    | Actions.PersonPhones.PersonPhoneGetByIdSuccessAction
    | Actions.PersonPhones.PersonPhoneGetByIdFailureAction
    | Actions.PersonPhones.PersonPhoneCreateRequestAction
    | Actions.PersonPhones.PersonPhoneCreateSuccessAction
    | Actions.PersonPhones.PersonPhoneCreateFailureAction
    | Actions.PersonPhones.PersonPhoneUpdateRequestAction
    | Actions.PersonPhones.PersonPhoneUpdateSuccessAction
    | Actions.PersonPhones.PersonPhoneUpdateFailureAction
    | Actions.PersonPhones.PersonPhoneDeleteRequestAction
    | Actions.PersonPhones.PersonPhoneDeleteSuccessAction
    | Actions.PersonPhones.PersonPhoneDeleteFailureAction;

export const PersonPhonesReducer: Reducer<PersonPhoneState> = (
    state: PersonPhoneState | undefined,
    incomingAction: Action
): PersonPhoneState => {
    if (state === undefined) {
        return PersonPhoneUnloadState as PersonPhoneState;
    }

    const action = incomingAction as KnownAction;

    switch (action.type) {
        case ActionEvents.PERSON_PHONE_GETALL_REQUEST:
            return {
                ...state,
                isLoadingAll: true,
                successLoadingAll: undefined,
                failOnLoadingAll: false,
                error: undefined
            };
        case ActionEvents.PERSON_PHONE_GETALL_SUCCESS: {
            const otherPersons = state.list.filter((item: PhoneViewModel) => item.personId !== action.personId);
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: true,
                failOnLoadingAll: false,
                list: [...otherPersons, ...action.payload],
                error: undefined
            };
        }
        case ActionEvents.PERSON_PHONE_GETALL_FAILURE:
            return {
                ...state,
                isLoadingAll: false,
                successLoadingAll: false,
                failOnLoadingAll: true,
                error: action.error
            };

        case ActionEvents.PERSON_PHONE_GETBYID_REQUEST:
            return {
                ...state,
                isLoadingOne: true,
                successLoadingOne: undefined,
                failOnLoadingOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_PHONE_GETBYID_SUCCESS: {
            const filtered = state.list.filter((item: PhoneViewModel) => item.id !== action.payload.id);
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                list: [...filtered, action.payload],
                error: undefined
            };
        }
        case ActionEvents.PERSON_PHONE_GETBYID_FAILURE:
            return {
                ...state,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: action.error
            };

        case ActionEvents.PERSON_PHONE_CREATE_REQUEST:
            return {
                ...state,
                isAddingNewOne: true,
                successAddingNewOne: undefined,
                failOnAddingNewOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_PHONE_CREATE_SUCCESS: {
            const createdList = state.list.some((item: PhoneViewModel) => item.id === action.payload.id)
                ? state.list.map((item: PhoneViewModel) => (item.id === action.payload.id ? action.payload : item))
                : [...state.list, action.payload];
            return {
                ...state,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                lastCreated: action.payload,
                list: createdList,
                error: undefined
            };
        }
        case ActionEvents.PERSON_PHONE_CREATE_FAILURE:
            return {
                ...state,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: action.error
            };

        case ActionEvents.PERSON_PHONE_UPDATE_REQUEST:
            return {
                ...state,
                isUpdatingOne: true,
                successUpdatingOne: undefined,
                failOnUpdatingOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_PHONE_UPDATE_SUCCESS: {
            const updatedList = state.list.some((item: PhoneViewModel) => item.id === action.payload.id)
                ? state.list.map((item: PhoneViewModel) => (item.id === action.payload.id ? { ...item, ...action.payload } : item))
                : [...state.list, action.payload];
            return {
                ...state,
                isUpdatingOne: false,
                successUpdatingOne: true,
                failOnUpdatingOne: false,
                list: updatedList,
                error: undefined
            };
        }
        case ActionEvents.PERSON_PHONE_UPDATE_FAILURE:
            return {
                ...state,
                isUpdatingOne: false,
                successUpdatingOne: false,
                failOnUpdatingOne: true,
                error: action.error
            };

        case ActionEvents.PERSON_PHONE_DELETE_REQUEST:
            return {
                ...state,
                isDeletingOne: true,
                successDeletingOne: undefined,
                failOnDeletingOne: false,
                error: undefined
            };
        case ActionEvents.PERSON_PHONE_DELETE_SUCCESS:
            return {
                ...state,
                isDeletingOne: false,
                successDeletingOne: true,
                failOnDeletingOne: false,
                list: state.list.filter((item: PhoneViewModel) => item.id !== action.id),
                error: undefined
            };
        case ActionEvents.PERSON_PHONE_DELETE_FAILURE:
            return {
                ...state,
                isDeletingOne: false,
                successDeletingOne: false,
                failOnDeletingOne: true,
                error: action.error
            };
        default:
            return state;
    }
};
